const MuiTypography = {
  styleOverrides: {
    gutterBottom: {
      marginBottom: '0.7em',
    },
  },
};

export default MuiTypography;
